import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ArrowRight } from 'lucide-react';
import PageBanner from '../components/common/PageBanner';
import { Section, Head } from '../components/common/Primitives';
import { faqs, contact } from '../data/site';
import banner from '../assets/banners/faq.jpg';

const FAQ = () => {
  const [open, setOpen] = useState('0-0');

  return (
    <div>
      <PageBanner
        image={banner}
        kicker="FAQ"
        title="Questions, answered"
        lead="Membership, growing methods, and how much of the system is actually automated."
      />

      <Section tone="paper">
        <div className="max-w-3xl mx-auto space-y-14">
          {faqs.map((group, gi) => (
            <div key={group.category}>
              <h2 className="label text-forest">{group.category}</h2>
              <div className="mt-6 space-y-3">
                {group.items.map((item, ii) => {
                  const key = `${gi}-${ii}`;
                  const isOpen = open === key;
                  return (
                    <div
                      key={item.q}
                      className="rounded-xl bg-chalk ring-1 ring-soil/10 overflow-hidden"
                    >
                      <button
                        onClick={() => setOpen(isOpen ? null : key)}
                        aria-expanded={isOpen}
                        className="w-full flex items-start justify-between gap-5 text-left p-5 hover:bg-paper2/50 transition-colors"
                      >
                        <span className="font-medium text-ink text-[15.5px] leading-snug">
                          {item.q}
                        </span>
                        <ChevronDown
                          className={`w-5 h-5 text-forest shrink-0 mt-0.5 transition-transform ${
                            isOpen ? 'rotate-180' : ''
                          }`}
                        />
                      </button>
                      {isOpen && (
                        <div className="px-5 pb-5 -mt-1">
                          <p className="text-soil/70 text-[14.5px] leading-relaxed">{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section tone="ink">
        <div className="max-w-2xl mx-auto text-center">
          <Head
            tone="dark"
            eyebrow="Still have a question"
            title="Ask us directly"
            lead="If it is about the technology, we are happy to go as deep as you want to go."
            center
          />
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            <a
              href={contact.emailHref}
              className="inline-flex items-center gap-2 rounded-full bg-lime text-ink px-7 py-3.5 font-semibold hover:bg-paper transition-colors"
            >
              Email us <ArrowRight className="w-4 h-4" />
            </a>
            <Link
              to="/farm-tech/system"
              className="inline-flex items-center gap-2 rounded-full ring-1 ring-white/20 px-7 py-3.5 font-medium text-paper hover:ring-lime hover:text-lime transition-colors"
            >
              Read the architecture
            </Link>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default FAQ;
